<!-- 大屏左侧设备状态统计卡片 -->
<template>
    <div class="box">
        <div class="tTitle">
            <div class="fTitleBorderTop"></div>
            设备状态统计
        </div>
        <div class="deviceStatusContent">
            <div class="alarmBox">
                <div class="title">报警状态</div>
                <div class="content">
                    <div class="left list">
                        <div class="count">{{ alarmData.normal }}</div>
                        <div class="tag">正常</div>
                    </div>
                    <div class="right list">
                        <div class="count">{{ alarmData.alarm }}</div>
                        <div class="tag">报警</div>
                    </div>
                </div>
            </div>
            <div class="onlineBox">
                <div class="title">在线状态</div>
                <div class="content">
                    <div ref="canva1" class="canva"></div>
                    <div ref="canva2" class="canva"></div>
                    <div ref="canva3" class="canva"></div>
                    <div ref="canva4" class="canva"></div>
                </div>
            </div>
        </div>
        <msLoading ref="loading"></msLoading>
    </div>
</template>

<script>
import msLoading from '@/components/common/msLoading.vue';
import { mapGetters } from 'vuex';
export default {
    name: 'leftcard1',
    props: {},
    data() {
        return {
            computerDataObj: {},
            alarmData: {
                alarm: 0,
                normal: 0
            }
        };
    },
    mounted() {
        this.onlineStatus();
        this.alarmStatus();
        this.leftcard('canva1', '#2392ff', '#124683', this.computerDataObj.allNumber, this.computerDataObj.allNumber, '#b6bec5', '总数');
        this.leftcard('canva2', '#33cc99', '#175855', this.computerDataObj.normalNumber, this.computerDataObj.allNumber, '#b6bec5', '正常');
        this.leftcard(
            'canva3',
            '#e83c03',
            '#b33105',
            this.computerDataObj.troubleNumber,
            this.computerDataObj.allNumber,
            '#b6bec5',
            '离线'
        );
        this.leftcard(
            'canva4',
            '#ef742f',
            '#59332c',
            this.computerDataObj.maintainNumber,
            this.computerDataObj.allNumber,
            '#b6bec5',
            '维护'
        );
    },
    computed: {
        ...mapGetters(['getNewDeviceData'])
    },
    methods: {
        // 在线状态统计
        onlineStatus() {
            let allNumber = 0

            if (JSON.parse(localStorage.getItem('companyInfo')).companyId == 45) {
                allNumber = this.$store.state.deviceNowData.length - 2;
            } else {
                allNumber = this.$store.state.deviceNowData.length
            }
            let maintainNumber = 0;
            let normalNumber = 0;
            let troubleNumber = 0;

            // 获取维护设备数量
            this.$store.state.deviceNowData.forEach((item, index) => {
                if (item.maintain === '1') {
                    maintainNumber++;
                    this.$store.state.deviceNowData[index].onLineStatus = '1';
                }
            });

            // 超时三天未上线即为故障

            this.$store.state.deviceNowData.forEach((item, index) => {
                if (item.projectId == 'SDbxgT' || item.deviceType == '智能井盖' || item.projectId == 'SDbsj' || item.projectId == 'SDbsjC') {
                    return
                }

                if (JSON.parse(localStorage.getItem('companyInfo')).companyId == 2) {
                    if (new Date().getTime() - item.updateTime > 259200000 * 100) {
                        console.log(item, 'itemitemitem');
                        troubleNumber++;
                        this.$store.state.deviceNowData[index].onLineStatus = '2';
                    }
                } else {
                    if (new Date().getTime() - item.updateTime > 259200000) {
                        console.log(item, 'itemitemitem');
                        troubleNumber++;
                        this.$store.state.deviceNowData[index].onLineStatus = '2';
                    }
                }

            });

            // 正常设备数量等于总数-故障-维护
            normalNumber = allNumber - maintainNumber - troubleNumber;
            this.computerDataObj = {
                allNumber,
                maintainNumber,
                normalNumber,
                troubleNumber
            };
        },

        // 报警状态统计
        alarmStatus() {
            let data = this.getNewDeviceData;
            let allNumber = 0

            if (JSON.parse(localStorage.getItem('companyInfo')).companyId == 45) {
                allNumber = this.getNewDeviceData.length - 2;
            } else {
                allNumber = this.getNewDeviceData.length;
            }
            let alarmData = data.filter((item) => {
                return item.alarmStatus;

            });
            console.log(alarmData, 'alarmData');
            let alarm = alarmData.length;
            let normal = allNumber - alarmData.length;
            this.$set(this.alarmData, 'alarm', alarm);
            this.$set(this.alarmData, 'normal', normal);
        },

        leftcard(dom, color1, color2, value, max, color3, text) {
            this.$refs.loading.show();
            this.$echarts.init(eval(`this.$refs.${dom}`)).setOption({
                series: [
                    {
                        type: 'gauge', // 测量仪
                        center: ['50%', '50%'], // 图形坐标位置 左, 右
                        radius: '100%', // 控制饼图的大小
                        startAngle: 90, // 开始位置
                        endAngle: -270, // 结束位置
                        pointer: {
                            // 显示仪表盘指针
                            show: false // 是否显示仪表盘指针
                        },
                        progress: {
                            // 展示当前进度。
                            show: true, // 是否展示进度条
                            overlap: false, // 是否重叠
                            roundCap: true, // 是否圆顶
                            clip: false, // 是否裁掉超出部分
                            itemStyle: {
                                // 设置圆形
                                color: color1 // 设置进度条初期式样
                            }
                        },
                        axisLine: {
                            // 设置线条
                            lineStyle: {
                                width: 5, // 线条宽度
                                color: [[1, color2]] // 不透明度, 线条设置背景色
                            }
                        },
                        splitLine: {
                            // 分隔线样式。
                            show: false, // 是否显示分隔线。
                            distance: 0, // 分隔线与轴线的距离。
                            length: 1033 // 分隔线线长。支持相对半径的百分比。
                        },
                        axisTick: {
                            // 刻度样式。
                            show: false // 是否显示刻度。
                        },
                        axisLabel: {
                            //刻度标签。
                            show: false, // 是否显示标签。
                            distance: 50 // 标签与刻度线的距离。
                        },
                        max: max, // 设置线条终点
                        data: [
                            {
                                value: value, // 可写变量  此value 对应 formatter: '{value}%' 中的Value  64类型不对请用'64'
                                detail: {
                                    // 仪表盘边框数据详情，用于显示数据。
                                    valueAnimation: false, // 是否开启标签的数字动画。
                                    offsetCenter: ['0%', '0%'], // 相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
                                    fontSize: 18 // 文字的字体大小。
                                }
                            }
                        ],
                        detail: {
                            //仪表盘详情，用于显示数据 仪表盘中间数字数据。
                            color: color3, // 文本颜色，默认取数值所在的区间的颜色
                            formatter: `{value}\n${text}` // 格式化函数或者字符串  formatter: function (value) { return value.toFixed(0);}
                        }
                    }
                ]
            });
            this.$refs.loading.hide();
        }
    },
    watch: {
        getNewDeviceData() {
            this.alarmStatus();
        }
    },
    components: {
        msLoading
    }
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    position: relative;

    .tTitle {
        width: 0.8rem;
        word-wrap: break-word;
        font-size: 0.4rem;
        font-weight: bold;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 0.1rem;
        border-right: 1px solid #14283e;
        background-color: #000;

        .fTitleBorderTop {
            width: 0.4rem;
            height: 0.1rem;
            background-color: #6fcd8c;
        }
    }

    .deviceStatusContent {
        width: 100%;
        height: 100%;

        .alarmBox {
            width: 100%;
            height: 50%;
            box-sizing: border-box;
            padding: 10px;
            border-bottom: 1px solid #14283e;

            .content {
                display: flex;
                font-size: 0.2rem;
                overflow: hidden;

                .left {}

                .right {}

                .list {
                    width: 50%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;

                    .count {
                        font-size: 1rem;
                        color: #66bbf9;
                    }

                    .tag {
                        font-size: 0.4rem;
                        font-weight: bold;
                        letter-spacing: 2px;
                    }
                }
            }
        }

        .onlineBox {
            width: 100%;
            height: 50%;
            padding: 10px;
            box-sizing: border-box;
            overflow: hidden;

            .content {
                width: 100%;
                display: flex;
                justify-content: space-between;
                font-size: 0.2rem;
                overflow: hidden;
            }

            .canva {
                width: 22%;
                box-sizing: border-box;
                padding: 5px;
            }
        }

        .title {
            letter-spacing: 2px;
            font-size: 0.3rem;
            color: #c2c5ce;
        }
    }
}
</style>